// Seconds since the person last touched THIS page (pointer, key, touch,
// scroll, or bringing the tab back to the front). The API client sends it on
// every request as X-User-Idle-Seconds so the server can tell a click from
// the app's own background polling: only real activity keeps a session alive
// (idle sign-out after 1 hour, operator 2026-10-17). Nothing here is sent
// anywhere else and no keystroke content is recorded — only the time.
let lastInputAt = Date.now();
const mark = () => { lastInputAt = Date.now(); };

if (typeof window !== 'undefined') {
  ['pointerdown', 'keydown', 'touchstart', 'wheel', 'scroll'].forEach((ev) =>
    window.addEventListener(ev, mark, { passive: true, capture: true }));
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') mark();
  });
}

export const idleSeconds = () => Math.max(0, Math.floor((Date.now() - lastInputAt) / 1000));
export const markUserActivity = mark;
